module.exports = __webpack_public_path__ + "img/abimg7.2b84996f.png";